<template>
    <InputRangeTwoKnobbedWithInputsContainer>
        <InputRangeTwoKnobbed
            v-bind="props"
            v-model="model"
        />

        <InputRangeTextInputs
            v-bind="props"
            v-model="model"
        />
    </InputRangeTwoKnobbedWithInputsContainer>
</template>

<script lang="ts" setup>
import { useModel } from 'vue'

import {
    defaults,
    type Props,
} from '@/components/ui/inputs/range/input-range-two-knobbed-props.ts'

import InputRangeTwoKnobbed from '@/components/ui/inputs/range/InputRangeTwoKnobbed.vue'
import InputRangeTextInputs from '@/components/ui/inputs/range/InputRangeTextInputs.vue'
import InputRangeTwoKnobbedWithInputsContainer from '@/components/ui/inputs/range/InputRangeTwoKnobbedWithInputsContainer.vue'

const props = withDefaults(defineProps<Props>(), defaults)

const model = useModel(props, 'modelValue')
</script>
